var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Box, Menu as MenuItem } from "grommet";
import styled from "styled-components";
var MenuNavLink = styled.a(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      '\n  text-decoration: none;\n  font-size: 18px;\n  line-height: 17px;\n  font-weight: 400;\n  color: black;\n  font-family: "Gotham Pro", sans-serif;\n  margin-right: 33px;\n\n  &:focus {\n    background-color: rgba(243, 243, 243, 1);\n    font-weight: 700;\n  }\n',
    ]))
);
var menu = [
  {
    name: "First",
    path: "",
  },
  {
    name: "Second",
    path: "",
  },
];
export var Menu = function Menu(_ref) {
  var as = _ref.as;
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      width: {
        max: "400px",
      },
    },
    /*#__PURE__*/ React.createElement(MenuItem, {
      label: "Select",
      dropProps: {
        align: {
          top: "bottom",
          left: "left",
        },
      },
      style: {
        boxShadow: "rgba(0, 0, 0, 0,25)",
        lineHeight: "17px",
        letterSpacing: "0.5px",
      },
      items: menu.map(function (item) {
        return {
          label: /*#__PURE__*/ React.createElement(
            MenuNavLink,
            {
              as: as,
              to: item.path,
            },
            item.name
          ),
          onClick: function onClick() {},
        };
      }),
    })
  );
};
